export function lowerCase(str: string) {
  return str.replace("ı", "i").replace("İ", "i").toLocaleLowerCase("en-US");
}
